import axios from 'axios';
import { GameDetail } from '../types/gameDetail';
import { API_URL } from '../constants/api';

export const missionDetailService = {
  // Получить детальную информацию об airsoft миссии
  getAirsoftMissionDetail: async (missionId: string): Promise<GameDetail> => {
    try {
      const response = await axios.get(`${API_URL}/api/missions/airsoft/${missionId}`);
      return response.data;
    } catch (error) {
      console.error('Ошибка получения детальной информации об airsoft миссии:', error);
      throw error;
    }
  },

  // Получить детальную информацию о paintball миссии
  getPaintballMissionDetail: async (missionId: string): Promise<GameDetail> => {
    try {
      const response = await axios.get(`${API_URL}/api/missions/paintball/${missionId}`);
      return response.data;
    } catch (error) {
      console.error('Ошибка получения детальной информации о paintball миссии:', error);
      throw error;
    }
  }
};